import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '../error&timer/loading.service';
import { finalize } from 'rxjs';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Solo mostrar loading para ciertas URLs (opcional)
  if (req.url.includes('/api/')) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (req.url.includes('/api/')) {
        setTimeout(() => {
          loadingService.hide();
        }, 300);
      }
    })
  );
};
